import app from 'main.js';

const updateHeaderAndFooter = (showHeader = true, showFooter = true) => {
  app.$root.$emit('updateHeaderAndFooter', {
    showHeader,
    showFooter,
  });
};

export default updateHeaderAndFooter;
